import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { brandColors } from '../theme';

const SectionHeading = ({ label, title, subtitle, align = 'center', dark = false }) => (
  <Box sx={{ textAlign: align, mb: { xs: 4, md: 6 }, px: { xs: 0.5, sm: 0 } }}>
    {label && (
      <Chip
        label={label}
        size="small"
        sx={{
          mb: 2,
          fontWeight: 600,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          fontSize: '0.7rem',
          bgcolor: dark ? 'rgba(201, 169, 98, 0.2)' : 'rgba(201, 169, 98, 0.15)',
          color: dark ? brandColors.goldLight : brandColors.gold,
          border: `1px solid ${dark ? 'rgba(201, 169, 98, 0.35)' : 'rgba(201, 169, 98, 0.3)'}`,
        }}
      />
    )}
    <Typography
      variant="h2"
      component="h2"
      sx={{
        color: dark ? '#fff' : 'text.primary',
        fontSize: { xs: '1.6rem', sm: '1.85rem', md: '2.35rem' },
        maxWidth: align === 'center' ? 720 : 'none',
        mx: align === 'center' ? 'auto' : 0,
        lineHeight: 1.25,
      }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography
        variant="subtitle1"
        sx={{
          mt: 2,
          color: dark ? 'rgba(255,255,255,0.75)' : 'text.secondary',
          maxWidth: 640,
          mx: align === 'center' ? 'auto' : 0,
          fontSize: { xs: '0.95rem', md: '1.1rem' },
          px: { xs: 0.5, sm: 0 },
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeading;
